import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'

const selectBookings = createSelector(
	[
		(state) => {
			return state.data[dataConstants.BOOKINGS_PAST];
		},
		(state) => {
			return state.data[dataConstants.BOOKINGS];
		},
	],
	( bookings, bookingsPast ) => {
		return {
			...bookingsPast,
			...bookings
		}
	}
)

export default selectBookings;